import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { SET_FEATURES } from './types';
export default _defineProperty({}, SET_FEATURES, function (state, features) {
  state.features = features;
});